import React from "react";
import orangeBorder from "../assets/images/orange-border.png";
import "./Analysis.css";

const borderColor = {
  Good: "#7BA720",
  Poor: "#F34868",
  Average: "#F9A500",
};

function Analysis(props) {
  return (
    <div
      className="general-analysis-container"
      style={{ backgroundColor: `${props.bgColor}` }}
    >
      <div className="general-analysis-top-div">
        <span>{props.heading}</span>
        <div className="general-analysis-top-div-img">
          <img src={orangeBorder} />
        </div>

        <div>{props.description}</div>
      </div>
      <div>
        <div className="general-analysis-mid-img">
          <img src={props.analysisImg} />
        </div>
        <div
          className="general-analysis-last-div"
          style={{ borderLeft: `5px solid ${props.borderColor}` }}
        >
          <div>
            <span
              style={{ color: `${props.borderColor}` }}
            >{`${props.tag}: `}</span>
            <span>{props.remarks}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Analysis;
